<template>
  <CartNotification
    hide-close-button
    class="hidden-sm-and-down"
  >
    <template #header>
      <span class="font-weight-bold font16">{{ headerText }}</span>
    </template>
    <!-- Cart items -->
    <template v-if="cartIsFilled" #content>
      <ProductOfTheMonthProgressBar variant="flyout" />
      <VRow no-gutters>
        <VCol class="px-0 overflow-y-auto overflow-x-hidden pb-3">
          <CartNotificationItem
            v-for="(cartProduct, index) in cartProducts"
            :key="index"
            :product="cartProduct"
            :quantity-text="quantityText"
            :item-price-text="getItemPriceText(cartProduct)"
            :is-sale="getIsSale(cartProduct)"
            :cart-state-notification="true"
            class="mb-3"
          />
        </VCol>
      </VRow>
      <VRow no-gutters class="mt-n2">
        <VCol class="font-weight-bold text-uppercase">
          {{ subTotalText }}
        </VCol>
        <VSpacer />
        <VCol class="font-weight-bold font18 text-right">
          {{ subTotal }}
        </VCol>
      </VRow>
    </template>
    <!-- Empty -->
    <template v-else #content>
      <VRow no-gutters data-testid="emptyCartText" class="mt-2 text-uppercase font-weight-bold">
        <VCol>
          {{ emptyCartText }}
        </VCol>
      </VRow>
    </template>
    <template #action>
      <CartNotificationButton
        @terminate-notification="emits('terminate-notification')"
      />
    </template>
  </CartNotification>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import CartNotification from '~/components/notification/cart/base/CartNotification.vue'
import CartNotificationItem from '~/components/notification/cart/common/CartNotificationItem.vue'
import CartNotificationButton from '~/components/notification/cart/common/CartNotificationButton.vue'
import ProductOfTheMonthProgressBar from '~/components/cart/ProductOfTheMonthProgressBar.vue'
import type { CartProduct } from '~/types/cart'
import { useCartStore } from '~/stores/cart'

const emits = defineEmits<{
  (e: 'terminate-notification'): void
}>()

const $i18n = useI18n()

const cartStore = useCartStore()

const { summary: cartSummary, items: cartProducts } = storeToRefs(cartStore)


const cartIsFilled = computed(() => cartProducts.value.length)
const subTotal = computed(() => cartSummary.value.formattedTotal)

const subTotalText = computed(() => $i18n.t('notifications.cart-state.subtotal.text'))
const quantityText = computed(() => $i18n.t('notifications.cart-state.qty.text'))
const headerText = computed(() =>  $i18n.t('notifications.cart-state.header.text', { productQty: '1' }))
const emptyCartText = computed(() =>  $i18n.t('notifications.cart-state.empty.text'))

const getIsSale = (cartProduct: CartProduct) => cartProduct.originalPrice > 0

const getItemPriceText = (cartProduct: CartProduct) => {
  const itemPriceFormatted = cartProduct.formattedItemPrice
  return $i18n.t('notifications.cart-state.item.price.text', { itemPrice: itemPriceFormatted })
}
</script>

<style lang="scss">
</style>
